import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.applicants.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-applicants-item',
template: templateSource || '',
    styles: [``],
})
export class PageApplicantsItemComponent implements OnInit {
    public id: string = '';
    public loading: boolean = true;
    public item: any = null;
    public selectedFile: any = null;
    public dragActive: boolean = false;
    public uploading: boolean = false;
    public exporting: boolean = false;
    public googleExporting: boolean = false;
    public processingFileId: string = "";
    public uploadProgress: number = 0;
    public uploadByteProgress: number = 0;
    public uploadState: string = "";
    public uploadMessage: string = "";
    public uploadModalOpen: boolean = false;
    public uploadModalCanClose: boolean = false;
    public uploadModalError: string = "";
    public uploadStageLabel: string = "";
    public uploadModalFileName: string = "";
    public uploadModalFileSize: string = "";
    public extracting: boolean = false;
    public matching: boolean = false;
    public checking: boolean = false;
    public recalculatingScores: boolean = false;
    public runningRetentionDryRun: boolean = false;
    public stageChanging: boolean = false;
    public creatingInterviewRound: boolean = false;
    public assigningInterviewerRoundId: string = "";
    public cancelingAssignmentId: string = "";
    public confirmingRejection: boolean = false;
    public savingReapplicationEligibility: boolean = false;
    public savingOffer: boolean = false;
    public changingOfferStatus: boolean = false;
    public confirmingFinalAcceptance: boolean = false;
    public stageChangeWarnings: any[] = [];
    public stageChangeForm: any = {
        to_stage: "",
        reason: "",
        note: ""
    };
    public interviewRoundForm: any = {
        round_type: "",
        scheduled_at: "",
        location_or_link: ""
    };
    public interviewerForms: any = {};
    public rejectionForm: any = {
        stage: "",
        reason_category: "",
        reason_note: ""
    };
    public reapplicationForm: any = {
        reapply_allowed: "true",
        available_from: "",
        reason: ""
    };
    public offerForm: any = {
        proposed_position: "",
        proposed_start_date: "",
        compensation_note: "",
        negotiation_note: ""
    };
    public offerStatusForm: any = {
        to_status: "",
        reason_category: "",
        note: ""
    };
    public finalAcceptanceForm: any = {
        reason_category: "",
        note: ""
    };
    public exportJobs: any[] = [];
    public exportPermissions: any = {
        can_create_limited: false,
        can_google_placeholder: false,
        can_download: false,
        can_admin_masked: false,
        limited_status_label: "권한 확인 중",
        download_status_label: "권한 확인 중",
        admin_masked_status_label: "관리자 승인 기능 전까지 비활성",
        google_sheets_status_label: "관리자 승인 및 연동 설정 후 사용 가능"
    };
    public uploadPermissions: any = {
        can_upload_applicant: false
    };
    public uploadPolicy: any = {
        max_upload_mb: 100,
        max_upload_bytes: 100 * 1024 * 1024,
        max_bytes: 100 * 1024 * 1024,
        allowed_extensions: [".pdf"],
        allowed_mime_types: ["application/pdf", "application/x-pdf"],
        solo_admin_mode: true,
        ui_policy: {
            solo_admin_mode: true
        }
    };

    constructor(@Inject( Service) public service: Service) {
        this.id = WizRoute.segment.id;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadUploadPolicy();
        await this.loadUploadPermissions();
        await this.load();
    }

    public async loadUploadPolicy() {
        const { code, data } = await wiz.call("upload_policy");
        if (code === 200 && data) this.uploadPolicy = { ...this.uploadPolicy, ...data };
    }

    public async loadUploadPermissions() {
        const { code, data } = await wiz.call("upload_permissions");
        if (code === 200 && data) this.uploadPermissions = data;
    }

    public canUploadApplicant() {
        return !!this.uploadPermissions?.can_upload_applicant;
    }

    public uploadPermissionStatus() {
        return this.canUploadApplicant() ? "available" : "PERMISSION_REQUIRED";
    }

    public uploadPermissionLabel() {
        return this.canUploadApplicant() ? "업로드 가능" : "업로드 권한 필요";
    }

    public uploadButtonLabel() {
        if (!this.canUploadApplicant()) return "업로드 권한 필요";
        if (!this.hasSelectedFile()) return "파일 선택 필요";
        return this.uploading ? "처리 중" : "업로드";
    }

    public uploadDropClass() {
        if (!this.canUploadApplicant()) return "border-zinc-200 bg-zinc-50";
        return this.dragActive ? "border-zinc-900 bg-zinc-50" : "border-zinc-300 bg-white";
    }

    public setUploadPermissionRequiredState() {
        if (this.canUploadApplicant()) return false;
        this.dragActive = false;
        this.selectedFile = null;
        this.uploadState = "PERMISSION_REQUIRED";
        this.uploadMessage = "업로드 권한 필요";
        this.uploadProgress = 0;
        return true;
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("get", { id: this.id });
        if (code === 200) {
            this.item = data;
            this.prepareStageChangeForm();
            this.prepareInterviewRoundForm();
            this.prepareOutcomeForms();
            this.prepareOfferForms();
        }
        await this.loadExportPermissions();
        await this.loadExports();

        this.loading = false;
        await this.service.render();
    }

    public prepareStageChangeForm() {
        if (!this.item || this.stageChangeForm.to_stage) return;
        const options = this.item.ats_stage_options || [];
        const next = options.find((stage: any) => !stage.disabled) || options[0] || null;
        this.stageChangeForm.to_stage = next?.stage_key || "";
    }

    public atsStages() {
        return this.item?.ats_stages || [];
    }

    public atsHistory() {
        return this.item?.ats_stage_history || [];
    }

    public detailPermissions() {
        return this.item?.detail_permissions || {};
    }

    public hasDetailPermission(name: string) {
        return !!this.detailPermissions()?.[name];
    }

    public canChangeAtsStage() {
        return this.hasDetailPermission("can_change_ats_stage")
            || !!this.item?.ats_stage_permissions?.can_change_ats_stage;
    }

    public stageChangeButtonLabel() {
        if (!this.canChangeAtsStage()) return "단계 변경 권한 필요";
        if (this.selectedAtsStageDisabled()) return "현재 단계에서 사용할 수 없음";
        return this.stageChanging ? "변경 중" : "단계 변경";
    }

    public selectedAtsStageLabel() {
        const key = this.stageChangeForm.to_stage;
        const stage = this.atsStages().find((item: any) => item.stage_key === key);
        return stage?.stage_label || stage?.label || key || "";
    }

    public selectedAtsStageDisabled() {
        const key = this.stageChangeForm.to_stage;
        const stage = (this.item?.ats_stage_options || []).find((item: any) => item.stage_key === key);
        return !!stage?.disabled;
    }

    public isTerminalStage(stageKey?: string) {
        const key = stageKey || this.stageChangeForm.to_stage;
        const stage = this.atsStages().find((item: any) => item.stage_key === key);
        return !!stage?.is_terminal;
    }

    public async changeAtsStage() {
        if (this.stageChanging) return;
        if (!this.canChangeAtsStage()) {
            await this.service.modal.error("ATS 단계 변경 권한이 필요합니다.");
            return;
        }
        if (!this.stageChangeForm.to_stage) {
            await this.service.modal.error("변경할 ATS 단계를 선택해주세요.");
            return;
        }
        if (this.selectedAtsStageDisabled()) {
            await this.service.modal.error("현재 단계에서 선택한 단계로 이동할 수 없습니다.");
            return;
        }

        this.stageChanging = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("change_stage", {
            id: this.id,
            applicant_id: this.id,
            to_stage: this.stageChangeForm.to_stage,
            reason: this.stageChangeForm.reason || "",
            note: this.stageChangeForm.note || ""
        });
        this.stageChanging = false;

        if (code === 200 && data?.ok !== false) {
            const warnings = data?.warnings || [];
            this.stageChangeForm = { to_stage: "", reason: "", note: "" };
            await this.load();
            this.stageChangeWarnings = warnings;
            await this.service.render();
            return;
        }

        this.stageChangeWarnings = data?.warnings || [];
        await this.service.modal.error(message || data?.message || "ATS 단계 변경에 실패했습니다.");
        await this.service.render();
    }

    public prepareInterviewRoundForm() {
        if (!this.item) return;
        if (!this.interviewRoundForm.round_type) {
            this.interviewRoundForm.round_type = this.item.interviews?.suggested_round_type || "FIRST_INTERVIEW";
        }
    }

    public interviewSummary() {
        return this.item?.interviews || {};
    }

    public interviewRounds() {
        return this.interviewSummary()?.rounds || [];
    }

    public interviewRoundTypes() {
        return this.interviewSummary()?.round_types || [];
    }

    public interviewPermissions() {
        return this.interviewSummary()?.permissions || {};
    }

    public canManageInterviews() {
        return this.hasDetailPermission("can_manage_interview")
            || this.hasDetailPermission("can_manage_interviews")
            || !!this.interviewPermissions()?.can_manage_interviews;
    }

    public canAssignInterviewers() {
        return this.hasDetailPermission("can_assign_interviewer")
            || this.hasDetailPermission("can_assign_interviewers")
            || !!this.interviewPermissions()?.can_assign_interviewers;
    }

    public interviewStageGuidance() {
        return this.interviewSummary()?.stage_guidance || {};
    }

    public interviewPermissionLabel() {
        if (this.canManageInterviews() || this.canAssignInterviewers()) return "관리 가능";
        if (this.interviewPermissions()?.can_view_interviews) return "조회 가능";
        return "권한 필요";
    }

    public outcomeSummary() {
        return this.item?.outcome || {};
    }

    public outcomePermissions() {
        return this.outcomeSummary()?.permissions || {};
    }

    public latestOutcome() {
        return this.outcomeSummary()?.latest_outcome || null;
    }

    public outcomeHistories() {
        return this.outcomeSummary()?.outcomes || [];
    }

    public reasonCategories() {
        return this.outcomeSummary()?.reason_categories || [];
    }

    public canConfirmOutcome() {
        return this.hasDetailPermission("can_confirm_rejection")
            || this.hasDetailPermission("can_confirm_outcome")
            || !!this.outcomePermissions()?.can_confirm_outcome;
    }

    public canManageReapplication() {
        return this.hasDetailPermission("can_manage_reapplication")
            || this.hasDetailPermission("can_manage_reapplication_policy")
            || this.canConfirmOutcome();
    }

    public prepareOutcomeForms() {
        const currentStage = this.item?.ats_stage?.current_stage || "DOCUMENT_REVIEW";
        const eligibility = this.outcomeSummary()?.reapplication_eligibility || {};
        this.rejectionForm = {
            stage: currentStage === "REJECTED" ? (this.item?.ats_stage?.previous_stage || "DOCUMENT_REVIEW") : currentStage,
            reason_category: this.rejectionForm.reason_category || "",
            reason_note: ""
        };
        this.reapplicationForm = {
            reapply_allowed: String(eligibility.reapply_allowed !== false),
            available_from: eligibility.available_from || "",
            reason: ""
        };
    }

    public rejectionButtonLabel() {
        if (!this.canConfirmOutcome()) return "권한 필요";
        return this.confirmingRejection ? "확정 중" : "불합격 확정";
    }

    public reapplicationButtonLabel() {
        if (!this.canManageReapplication()) return "권한 필요";
        return this.savingReapplicationEligibility ? "저장 중" : "재지원 가능 여부 저장";
    }

    public async confirmRejection() {
        if (this.confirmingRejection) return;
        if (!this.canConfirmOutcome()) {
            await this.service.modal.error("불합격 확정 권한이 필요합니다.");
            return;
        }
        if (!this.rejectionForm.reason_category) {
            await this.service.modal.error("불합격 사유 카테고리가 필요합니다.");
            return;
        }

        this.confirmingRejection = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("confirm_rejection", {
            id: this.id,
            applicant_id: this.id,
            stage: this.rejectionForm.stage || "",
            reason_category: this.rejectionForm.reason_category || "",
            reason_note: this.rejectionForm.reason_note || ""
        });
        this.confirmingRejection = false;

        if (code === 200 && data?.ok !== false) {
            this.item = data?.applicant || this.item;
            this.rejectionForm.reason_category = "";
            this.rejectionForm.reason_note = "";
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage({ message, data }, "불합격 확정 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async saveReapplicationEligibility() {
        if (this.savingReapplicationEligibility) return;
        if (!this.canManageReapplication()) {
            await this.service.modal.error("재지원 가능 여부 수정 권한이 필요합니다.");
            return;
        }

        this.savingReapplicationEligibility = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("update_reapplication_eligibility", {
            id: this.id,
            applicant_id: this.id,
            reapply_allowed: this.reapplicationForm.reapply_allowed,
            available_from: this.reapplicationForm.available_from || "",
            reason: this.reapplicationForm.reason || ""
        });
        this.savingReapplicationEligibility = false;

        if (code === 200 && data?.ok !== false) {
            this.item = data?.applicant || this.item;
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage({ message, data }, "재지원 가능 여부 저장 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public offerSummary() {
        return this.item?.offer || {};
    }

    public offerPermissions() {
        return this.offerSummary()?.permissions || {};
    }

    public offerNegotiation() {
        return this.offerSummary()?.negotiation || {};
    }

    public offerHistory() {
        return this.offerSummary()?.history || [];
    }

    public offerStatusOptions() {
        return this.offerSummary()?.status_options || [];
    }

    public offerReasonCategories() {
        return this.offerSummary()?.reason_categories || [];
    }

    public canViewOffer() {
        return this.hasDetailPermission("can_view_offer")
            || !!this.offerPermissions()?.can_view_offer;
    }

    public canManageOffer() {
        return this.hasDetailPermission("can_manage_offer")
            || !!this.offerPermissions()?.can_manage_offer;
    }

    public canConfirmFinalAcceptance() {
        return this.hasDetailPermission("can_confirm_final_acceptance")
            || !!this.offerPermissions()?.can_confirm_final_acceptance;
    }

    public prepareOfferForms() {
        const offer = this.offerNegotiation();
        this.offerForm = {
            proposed_position: offer.proposed_position || "",
            proposed_start_date: offer.proposed_start_date || "",
            compensation_note: offer.compensation_note || "",
            negotiation_note: offer.negotiation_note || ""
        };
        if (!this.offerStatusForm.to_status) {
            const options = this.offerStatusOptions();
            const current = offer.status || "NOT_STARTED";
            const next = options.find((option: any) => option.key !== current) || options[0] || null;
            this.offerStatusForm.to_status = next?.key || "";
        }
        this.offerStatusForm.reason_category = this.offerStatusForm.reason_category || "";
        this.offerStatusForm.note = "";
        this.finalAcceptanceForm.reason_category = this.finalAcceptanceForm.reason_category || "";
        this.finalAcceptanceForm.note = "";
    }

    public offerStatusLabel() {
        return this.offerNegotiation()?.status_label || "미시작";
    }

    public saveOfferButtonLabel() {
        if (!this.canManageOffer()) return "권한 필요";
        return this.savingOffer ? "저장 중" : "처우 협의 저장";
    }

    public changeOfferStatusButtonLabel() {
        if (!this.canManageOffer()) return "권한 필요";
        return this.changingOfferStatus ? "변경 중" : "협의 상태 변경";
    }

    public finalAcceptanceButtonLabel() {
        if (!this.canConfirmFinalAcceptance()) return "권한 필요";
        return this.confirmingFinalAcceptance ? "확정 중" : "최종 합격 확정";
    }

    public async saveOfferNegotiation() {
        if (this.savingOffer) return;
        if (!this.canManageOffer()) {
            await this.service.modal.error("처우 협의 관리 권한이 필요합니다.");
            return;
        }

        this.savingOffer = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("update_offer_negotiation", {
            id: this.id,
            applicant_id: this.id,
            proposed_position: this.offerForm.proposed_position || "",
            proposed_start_date: this.offerForm.proposed_start_date || "",
            compensation_note: this.offerForm.compensation_note || "",
            negotiation_note: this.offerForm.negotiation_note || ""
        });
        this.savingOffer = false;

        if (code === 200 && data?.ok !== false) {
            this.item = data?.applicant || this.item;
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage({ message, data }, "처우 협의 저장 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async changeOfferStatus() {
        if (this.changingOfferStatus) return;
        if (!this.canManageOffer()) {
            await this.service.modal.error("처우 협의 상태 변경 권한이 필요합니다.");
            return;
        }
        if (!this.offerStatusForm.to_status) {
            await this.service.modal.error("변경할 협의 상태를 선택해주세요.");
            return;
        }

        this.changingOfferStatus = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("change_offer_status", {
            id: this.id,
            applicant_id: this.id,
            to_status: this.offerStatusForm.to_status || "",
            reason_category: this.offerStatusForm.reason_category || "",
            note: this.offerStatusForm.note || ""
        });
        this.changingOfferStatus = false;

        if (code === 200 && data?.ok !== false) {
            this.item = data?.applicant || this.item;
            this.offerStatusForm = { to_status: "", reason_category: "", note: "" };
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage({ message, data }, "처우 협의 상태 변경 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async confirmFinalAcceptance() {
        if (this.confirmingFinalAcceptance) return;
        if (!this.canConfirmFinalAcceptance()) {
            await this.service.modal.error("최종 합격 확정 권한이 필요합니다.");
            return;
        }
        if (!this.finalAcceptanceForm.reason_category) {
            await this.service.modal.error("최종 합격 확정 사유 카테고리가 필요합니다.");
            return;
        }

        this.confirmingFinalAcceptance = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("confirm_final_acceptance", {
            id: this.id,
            applicant_id: this.id,
            reason_category: this.finalAcceptanceForm.reason_category || "",
            note: this.finalAcceptanceForm.note || ""
        });
        this.confirmingFinalAcceptance = false;

        if (code === 200 && data?.ok !== false) {
            this.item = data?.applicant || this.item;
            this.finalAcceptanceForm.reason_category = "";
            this.finalAcceptanceForm.note = "";
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage({ message, data }, "최종 합격 확정 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public interviewFormValue(round: any, field: string) {
        const form = this.ensureInterviewerForm(round);
        return form[field] || "";
    }

    public setInterviewerFormValue(round: any, field: string, value: any) {
        const form = this.ensureInterviewerForm(round);
        form[field] = value;
    }

    public ensureInterviewerForm(round: any) {
        const id = round?.id || "";
        if (!id) return {};
        if (!this.interviewerForms[id]) {
            this.interviewerForms[id] = {
                interviewer_user_id: "",
                interviewer_name: "",
                note: ""
            };
        }
        return this.interviewerForms[id];
    }

    public async createInterviewRound() {
        if (this.creatingInterviewRound) return;
        if (!this.canManageInterviews()) {
            await this.service.modal.error("면접 라운드 관리 권한이 필요합니다.");
            return;
        }
        if (!this.interviewRoundForm.round_type) {
            await this.service.modal.error("면접 차수를 선택해주세요.");
            return;
        }

        this.creatingInterviewRound = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("create_interview_round", {
            id: this.id,
            applicant_id: this.id,
            round_type: this.interviewRoundForm.round_type,
            scheduled_at: this.interviewRoundForm.scheduled_at || "",
            location_or_link: this.interviewRoundForm.location_or_link || ""
        });
        this.creatingInterviewRound = false;

        if (code === 200 && data?.ok !== false) {
            this.interviewRoundForm = {
                round_type: this.item?.interviews?.suggested_round_type || this.interviewRoundForm.round_type || "FIRST_INTERVIEW",
                scheduled_at: "",
                location_or_link: ""
            };
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage({ message, data }, "면접 라운드 생성 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async assignInterviewer(round: any) {
        if (!round?.id || this.assigningInterviewerRoundId) return;
        if (!this.canAssignInterviewers()) {
            await this.service.modal.error("면접관 배정 권한이 필요합니다.");
            return;
        }
        const form = this.ensureInterviewerForm(round);
        if (!(form.interviewer_user_id || "").trim()) {
            await this.service.modal.error("면접관 ID를 입력해주세요.");
            return;
        }

        this.assigningInterviewerRoundId = round.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("assign_interviewer", {
            round_id: round.id,
            interviewer_user_id: form.interviewer_user_id || "",
            interviewer_name: form.interviewer_name || "",
            note: form.note || ""
        });
        this.assigningInterviewerRoundId = "";

        if (code === 200 && data?.ok !== false) {
            this.interviewerForms[round.id] = {
                interviewer_user_id: "",
                interviewer_name: "",
                note: ""
            };
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage({ message, data }, "면접관 배정 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async cancelInterviewerAssignment(assignment: any) {
        if (!assignment?.id || this.cancelingAssignmentId) return;
        if (!this.canAssignInterviewers()) {
            await this.service.modal.error("면접관 배정 권한이 필요합니다.");
            return;
        }

        this.cancelingAssignmentId = assignment.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("cancel_interviewer_assignment", {
            assignment_id: assignment.id
        });
        this.cancelingAssignmentId = "";

        if (code === 200 && data?.ok !== false) {
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage({ message, data }, "면접관 배정 취소 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async loadExportPermissions() {
        const { code, data } = await wiz.call("export_permissions");
        if (code === 200 && data) this.exportPermissions = data;
    }

    public async loadExports() {
        const { code, data } = await wiz.call("exports", { id: this.id });
        if (code === 200) this.exportJobs = data || [];
    }

    public async createXlsxExport() {
        if (this.exporting) return;
        if (!this.exportPermissions.can_create_limited) {
            await this.service.modal.error("XLSX 내보내기 권한이 필요합니다.");
            return;
        }

        this.exporting = true;
        await this.service.render();

        const { code, message } = await wiz.call("create_xlsx_export", {
            id: this.id,
            export_profile: "limited"
        });
        this.exporting = false;

        if (code === 200) {
            await this.loadExports();
            await this.service.render();
            return;
        }

        await this.service.modal.error(message || "XLSX 내보내기 생성에 실패했습니다.");
        await this.service.render();
    }

    public async createGoogleSheetsPlaceholder() {
        if (this.googleExporting) return;
        if (!this.exportPermissions.can_google_placeholder) {
            await this.service.modal.error("Google Sheets placeholder 요청 권한이 필요합니다.");
            return;
        }

        this.googleExporting = true;
        await this.service.render();

        const { code, message } = await wiz.call("create_google_sheets_placeholder", { id: this.id });
        this.googleExporting = false;

        if (code === 200) {
            await this.loadExports();
            await this.service.render();
            return;
        }

        await this.service.modal.error(message || "Google Sheets placeholder 처리에 실패했습니다.");
        await this.service.render();
    }

    public async downloadExport(job: any) {
        if (!job?.download_available) return;
        if (!this.exportPermissions.can_download) {
            await this.service.modal.error("내보내기 파일 다운로드 권한이 필요합니다.");
            return;
        }
        window.location.href = `${wiz.url("download_export")}?id=${encodeURIComponent(job.id)}`;
    }

    public async selectFile(event: any, input?: any) {
        if (this.setUploadPermissionRequiredState()) {
            if (event?.target) event.target.value = "";
            await this.service.render();
            return;
        }
        const files = event?.target?.files || [];
        if (this.rejectMultipleFiles(files, input || event?.target)) {
            await this.service.render();
            return;
        }
        this.setSelectedFile(this.firstFile(files), input || event?.target);
        await this.service.render();
    }

    public setSelectedFile(file: any, input?: any) {
        this.uploadState = "";
        this.uploadMessage = "";
        this.uploadProgress = 0;
        this.selectedFile = null;
        if (!file) {
            this.clearFileInput(input);
            return;
        }
        if (!this.isUploadFile(file)) {
            this.uploadState = "failed";
            this.uploadMessage = "선택한 PDF 파일 정보를 확인할 수 없습니다. 파일을 다시 선택해주세요.";
            this.clearFileInput(input);
            return;
        }

        const error = this.validateClientFile(file);
        if (error) {
            this.uploadState = "failed";
            this.uploadMessage = error;
            this.clearFileInput(input);
            return;
        }
        this.selectedFile = file;
        this.clearFileInput(input);
    }

    public handleDragOver(event: any) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.canUploadApplicant()) return;
        this.dragActive = true;
    }

    public handleDragLeave(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.dragActive = false;
    }

    public async handleDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.dragActive = false;
        if (this.setUploadPermissionRequiredState()) {
            await this.service.render();
            return;
        }
        const files = event?.dataTransfer?.files || [];
        if (this.rejectMultipleFiles(files)) {
            await this.service.render();
            return;
        }
        this.setSelectedFile(this.firstFile(files));
        await this.service.render();
    }

    public async uploadPdf(event?: any, input?: any) {
        this.preventUploadButtonDefault(event);
        if (!this.canUploadApplicant()) {
            await this.service.modal.error("지원자 PDF 업로드 권한이 필요합니다.");
            return;
        }
        const file = this.currentSelectedFile();
        if (!file) {
            this.selectedFile = null;
            this.clearFileInput(input);
            this.uploadState = "failed";
            this.uploadMessage = "PDF 파일을 선택해주세요.";
            this.uploadProgress = 0;
            await this.service.modal.error("PDF 파일을 선택해주세요.");
            await this.service.render();
            return;
        }
        const validationError = this.validateClientFile(file);
        if (validationError) {
            this.uploadState = "failed";
            this.uploadMessage = validationError;
            this.selectedFile = null;
            this.clearFileInput(input);
            await this.service.modal.error(validationError);
            await this.service.render();
            return;
        }

        this.uploading = true;
        this.uploadState = "processing";
        this.uploadMessage = "파일 검증 중입니다.";
        this.openUploadProgressModal(file);
        this.setUploadStep("파일 검증 중", 5);
        await this.service.render();
        await this.advanceUploadStep("업로드 중", 10);

        const fd = new FormData();
        fd.append("id", this.id);
        fd.append("file[]", file, file.name);
        const uploadUrl = `${wiz.url("upload")}?id=${encodeURIComponent(this.id)}`;
        let raw: any = null;
        try {
            raw = await this.service.file.upload(uploadUrl, fd, async (percent: number) => {
                this.uploadByteProgress = Math.max(0, Math.min(100, Math.round(Number(percent || 0))));
                this.uploadProgress = Math.min(60, 10 + Math.round(this.uploadByteProgress * 0.5));
                this.uploadStageLabel = "업로드 중";
                this.uploadMessage = `업로드 중입니다. ${this.uploadByteProgress}%`;
                await this.service.render();
            });
        } catch (error) {
            this.uploading = false;
            this.uploadState = "failed";
            this.uploadMessage = this.safeErrorMessage(error);
            this.failUploadProgress(this.uploadMessage);
            await this.service.render();
            return;
        }
        await this.advanceUploadStep("서버 저장 중", 70);
        const { code, data, message } = this.normalizeApiResult(raw);

        if (code === 200 && data?.ok !== false) {
            await this.advanceUploadStep("문서 처리 중", 80);
            await this.advanceUploadStep("텍스트 추출 중", 86);
            await this.advanceUploadStep("문서 분류 중", 92);
            await this.advanceUploadStep("검토 정보 준비 중", 96);
            this.uploadState = data?.status || "completed";
            this.uploadMessage = data?.message || "PDF 업로드와 페이지 텍스트 추출/분류가 완료되었습니다.";
            this.selectedFile = null;
            this.clearFileInput(input);
            this.item = data?.applicant || data;
            await this.load();
            this.completeUploadProgress(this.uploadMessage);
            await this.service.render();
        } else {
            this.uploading = false;
            this.uploadState = "failed";
            this.uploadMessage = this.safeErrorMessage({ message, data });
            if (data?.uploaded_file) {
                this.selectedFile = null;
                this.clearFileInput(input);
            }
            if (data?.applicant) this.item = data.applicant;
            if (data?.applicant || data?.applicant_id) await this.load();
            this.failUploadProgress(this.uploadMessage);
            await this.service.render();
        }
    }

    public async processFile(file: any) {
        if (!file?.id || this.processingFileId) return;

        this.processingFileId = file.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("process_file", { id: this.id, file_id: file.id });
        this.processingFileId = "";

        if (code === 200) {
            this.item = data;
            await this.load();
        } else {
            await this.service.modal.error(message || "PDF 텍스트 추출 또는 페이지 처리 중 오류가 발생했습니다. 관리자 확인이 필요합니다.");
            await this.service.render();
        }
    }

    public async extractFields(file?: any) {
        if (this.extracting) return;

        this.extracting = true;
        await this.service.render();

        const params: any = { id: this.id };
        if (file?.id) params.file_id = file.id;
        const { code, data, message } = await wiz.call("extract_fields", params);
        this.extracting = false;

        if (code === 200) {
            this.item = data;
            await this.service.render();
        } else {
            await this.service.modal.error(message || "응시원서 필드 추출 중 오류가 발생했습니다.");
            await this.service.render();
        }
    }

    public async runEvidenceMatching(file?: any) {
        if (this.matching) return;

        this.matching = true;
        await this.service.render();

        const params: any = { id: this.id };
        if (file?.id) params.file_id = file.id;
        const { code, data, message } = await wiz.call("run_evidence_matching", params);
        this.matching = false;

        if (code === 200) {
            this.item = data;
            await this.service.render();
        } else {
            await this.service.modal.error(message || "증빙 매칭 실행 중 오류가 발생했습니다.");
            await this.service.render();
        }
    }

    public async runFormEligibilityChecks(file?: any) {
        if (this.checking) return;

        this.checking = true;
        await this.service.render();

        const params: any = { id: this.id };
        if (file?.id) params.file_id = file.id;
        const { code, data, message } = await wiz.call("run_form_eligibility_checks", params);
        this.checking = false;

        if (code === 200) {
            this.item = data;
            await this.service.render();
        } else {
            await this.service.modal.error(message || "양식·결격 검토 실행 중 오류가 발생했습니다.");
            await this.service.render();
        }
    }

    public async recalculateScores() {
        if (this.recalculatingScores) return;

        this.recalculatingScores = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("recalculate_scores", { id: this.id });
        this.recalculatingScores = false;

        if (code === 200) {
            this.item = data;
            await this.service.render();
        } else {
            await this.service.modal.error(message || "평가점수 재계산 중 오류가 발생했습니다.");
            await this.service.render();
        }
    }

    public async dryRunRetention() {
        if (this.runningRetentionDryRun) return;
        if (!this.item?.retention?.can_manage) {
            await this.service.modal.error("파기 관리 권한이 필요합니다.");
            return;
        }

        this.runningRetentionDryRun = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("retention_dry_run", { id: this.id });
        this.runningRetentionDryRun = false;

        if (code === 200) {
            this.item.retention = data;
            await this.service.render();
            return;
        }

        await this.service.modal.error(message || "파기 dry-run 처리에 실패했습니다.");
        await this.service.render();
    }

    public firstFile(files: any) {
        if (!files || !files.length) return null;
        if (typeof files.item === "function") return files.item(0);
        return files[0] || null;
    }

    public fileCount(files: any) {
        return files?.length || 0;
    }

    public rejectMultipleFiles(files: any, input?: any) {
        if (this.fileCount(files) <= 1) return false;
        this.selectedFile = null;
        this.uploadState = "failed";
        this.uploadMessage = "PDF 1개만 업로드할 수 있습니다.";
        this.uploadProgress = 0;
        this.uploadByteProgress = 0;
        this.clearFileInput(input);
        return true;
    }

    public isUploadFile(file: any) {
        return !!file
            && typeof file.name === "string"
            && typeof file.size === "number"
            && typeof file.slice === "function";
    }

    public currentSelectedFile() {
        return this.isUploadFile(this.selectedFile) ? this.selectedFile : null;
    }

    public hasSelectedFile() {
        return !!this.currentSelectedFile();
    }

    public selectedFileName() {
        const file = this.currentSelectedFile();
        return file ? file.name : "통합 PDF 1개를 선택하거나 드래그하세요";
    }

    public selectedFileDetail() {
        const file = this.currentSelectedFile();
        if (!file && this.uploadState === "failed" && this.uploadMessage) return this.uploadMessage;
        if (!file) return `통합 PDF 1개만 업로드할 수 있습니다. · 최대 ${this.uploadMaxLabel()}`;
        return `${this.formatBytes(file.size)} · 업로드 준비`;
    }

    public openUploadProgressModal(file: any) {
        this.uploadModalOpen = true;
        this.uploadModalCanClose = false;
        this.uploadModalError = "";
        this.uploadModalFileName = file?.name || "";
        this.uploadModalFileSize = this.formatBytes(file?.size || 0);
        this.uploadByteProgress = 0;
    }

    public setUploadStep(label: string, progress: number) {
        this.uploadStageLabel = label;
        this.uploadProgress = Math.max(0, Math.min(100, Math.round(progress || 0)));
        this.uploadMessage = label;
    }

    public async advanceUploadStep(label: string, progress: number) {
        this.setUploadStep(label, progress);
        await this.service.render();
    }

    public completeUploadProgress(message: string) {
        this.uploading = false;
        this.uploadModalCanClose = true;
        this.uploadModalError = "";
        this.uploadStageLabel = "완료";
        this.uploadProgress = 100;
        this.uploadByteProgress = 100;
        this.uploadState = "completed";
        this.uploadMessage = message || "PDF 업로드와 검토 정보 준비가 완료되었습니다.";
    }

    public failUploadProgress(message: string) {
        this.uploading = false;
        this.uploadModalCanClose = true;
        this.uploadStageLabel = "실패";
        this.uploadProgress = this.uploadProgress || 0;
        this.uploadState = "failed";
        this.uploadModalError = this.safeErrorMessage({ message });
        this.uploadMessage = this.uploadModalError;
    }

    public closeUploadModal() {
        if (this.uploading && !this.uploadModalCanClose) return;
        this.uploadModalOpen = false;
    }

    public async retryUploadFromModal() {
        if (this.uploading || !this.hasSelectedFile()) return;
        await this.uploadPdf();
    }

    public uploadModalCloseLabel() {
        if (this.uploading && !this.uploadModalCanClose) return "처리 중";
        return this.uploadState === "completed" ? "닫기" : "닫기";
    }

    public uploadSteps() {
        return [
            "파일 검증 중",
            "업로드 중",
            "서버 저장 중",
            "문서 처리 중",
            "텍스트 추출 중",
            "문서 분류 중",
            "검토 정보 준비 중",
            "완료",
        ];
    }

    public uploadStepIndex(label?: string) {
        const index = this.uploadSteps().indexOf(label || this.uploadStageLabel);
        return index < 0 ? 0 : index;
    }

    public uploadStepClass(step: string) {
        if (this.uploadState === "failed" && step === this.uploadStageLabel) return "border-rose-200 bg-rose-50 text-rose-700";
        const active = this.uploadStepIndex();
        const index = this.uploadStepIndex(step);
        if (index < active || this.uploadState === "completed") return "border-emerald-200 bg-emerald-50 text-emerald-700";
        if (index === active) return "border-sky-200 bg-sky-50 text-sky-700";
        return "border-zinc-200 bg-white text-zinc-500";
    }

    public uploadMaxBytes() {
        return Number(this.uploadPolicy?.max_upload_bytes || this.uploadPolicy?.max_bytes || 100 * 1024 * 1024);
    }

    public uploadMaxLabel() {
        const maxUploadMb = Number(this.uploadPolicy?.max_upload_mb || 0);
        if (maxUploadMb > 0) return `${maxUploadMb}MB`;
        return this.formatBytes(this.uploadMaxBytes());
    }

    public soloAdminMode() {
        const policy = this.uploadPolicy || {};
        if (policy.ui_policy && policy.ui_policy.solo_admin_mode !== undefined) {
            return !!policy.ui_policy.solo_admin_mode;
        }
        if (policy.solo_admin_mode !== undefined) return !!policy.solo_admin_mode;
        return true;
    }

    public compactStatusLabel(label: string) {
        if (!this.soloAdminMode()) return label || "";
        const text = label || "";
        if (text.indexOf("권한") >= 0) return text;
        if (text.indexOf("확정 필요") >= 0 || text.indexOf("확인 필요") >= 0 || text.indexOf("수동검토") >= 0 || text.indexOf("입력 필요") >= 0) return "확인 필요";
        if (text.indexOf("자동 산정 초안") >= 0) return "초안";
        if (text.indexOf("미확정") >= 0) return "미확정";
        return text;
    }

    public detailAttentionCount() {
        const pages = Number(this.item?.document_page_summary?.needs_review || 0);
        const evidence = Number(this.item?.evidence?.counts?.needs_review || 0);
        const form = Number(this.item?.form_eligibility?.counts?.form_needs_review || 0);
        const eligibility = Number(this.item?.form_eligibility?.counts?.eligibility_needs_review || 0);
        const scoring = Number(this.item?.scoring?.counts?.needs_review || 0);
        const retention = this.isAttentionStatus(this.item?.retention?.status) ? 1 : 0;
        return pages + evidence + form + eligibility + scoring + retention;
    }

    public detailAttentionLabel() {
        const count = this.detailAttentionCount();
        return count > 0 ? `확인 필요 ${count}건` : "확인 완료";
    }

    public isAttentionStatus(status: string) {
        return [
            "NEEDS_REVIEW",
            "NEEDS_HUMAN_REVIEW",
            "MANUAL_REVIEW_REQUIRED",
            "MANUAL_CHECK_REQUIRED",
            "REVIEWER_REQUIRED",
            "NEEDS_ADMIN_CONFIRMATION",
            "APPROVAL_REQUIRED",
            "APPROVAL_REQUESTED",
            "PENDING",
            "ON_HOLD",
        ].indexOf(status || "") >= 0;
    }

    public outcomeStatusLabel() {
        if (!this.soloAdminMode()) return this.outcomeSummary()?.is_rejected ? "불합격 확정" : "담당자 확정 필요";
        return this.outcomeSummary()?.is_rejected ? "불합격 확정" : "미확정";
    }

    public panelStatusLabel(panel: any) {
        return this.compactStatusLabel(panel?.status_label || "");
    }

    public panelDescription(panel: any) {
        if (!this.soloAdminMode()) return panel?.description || "";
        const text = panel?.description || "";
        return text
            .replace(/담당자가 확인한다\./g, "확인 대상입니다.")
            .replace(/자동 산정 초안/g, "초안")
            .replace(/담당자 또는 심사위원 입력으로만 확정한다\./g, "최종점수는 입력 후 확정합니다.");
    }

    public rubricStatusLabel() {
        return this.compactStatusLabel(this.item?.scoring?.rubric_status || "확인 필요");
    }

    public scoreReviewLabel(score: any) {
        return this.compactStatusLabel(score?.needs_review_label || "");
    }

    public scoreAutoLabel(score: any) {
        const label = score?.auto_score_label || "";
        if (!this.soloAdminMode()) return label;
        return label.replace(/자동 산정 초안\s*/g, "").replace("자동 산정 없음", "미산정") || label;
    }

    public scoreReviewerLabel(score: any) {
        const label = score?.reviewer_score_label || "";
        if (!this.soloAdminMode()) return label;
        if (label.indexOf("입력 필요") >= 0) return "미입력";
        return this.compactStatusLabel(label);
    }

    public scoreFinalLabel(score: any) {
        return this.compactStatusLabel(score?.final_score_label || "");
    }

    public scoreSourceLabel(score: any) {
        const label = score?.score_source_label || "";
        if (!this.soloAdminMode()) return label;
        return label.replace("자동 산정 초안", "초안").replace("자동 산정 없음", "미산정") || label;
    }

    public scoreInputLabel(score: any) {
        if (!this.soloAdminMode()) return score?.review_input_label || "";
        return this.compactStatusLabel(score?.review_input_label || "");
    }

    public clearFileInput(input?: any) {
        if (input) input.value = "";
    }

    public preventUploadButtonDefault(event?: any) {
        if (event?.preventDefault) event.preventDefault();
        if (event?.stopPropagation) event.stopPropagation();
    }

    public validateClientFile(file: any) {
        const name = (file?.name || "").toLowerCase();
        const extOk = (this.uploadPolicy.allowed_extensions || [".pdf"]).some((ext: string) => name.endsWith(ext));
        if (!extOk) return "PDF 확장자 파일만 업로드할 수 있습니다.";
        const allowedMime = this.uploadPolicy.allowed_mime_types || ["application/pdf"];
        if (file.type && allowedMime.indexOf(file.type) < 0) return "PDF MIME 타입 파일만 업로드할 수 있습니다.";
        if (file.size <= 0) return "빈 파일은 업로드할 수 없습니다.";
        if (file.size > this.uploadMaxBytes()) return `파일 크기는 ${this.uploadMaxLabel()} 이하만 허용됩니다.`;
        return "";
    }

    public normalizeApiResult(res: any) {
        if (!res) return { code: 500, data: null, message: "응답을 확인할 수 없습니다." };
        let payload = res;
        if (typeof res === "string") payload = this.parseJson(res) || res;
        if (res.responseJSON) payload = res.responseJSON;
        if (res.responseText && !res.responseJSON) payload = this.parseJson(res.responseText) || payload;
        if (payload?.code) {
            const data = payload.data === undefined ? null : payload.data;
            return {
                code: payload.code,
                data,
                message: this.safeErrorMessage({ message: payload.message, data }, "")
            };
        }
        if (res.status && res.status !== 200) {
            const data = payload?.data || null;
            return {
                code: res.status,
                data,
                message: this.safeErrorMessage({ data, response: payload, error: res.error, responseText: res.responseText })
            };
        }
        return { code: 200, data: payload, message: this.safeErrorMessage(payload, "") };
    }

    public parseJson(value: any) {
        if (!value || typeof value !== "string") return null;
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }

    public safeErrorMessage(error: any, fallback: string = "PDF 업로드에 실패했습니다. 파일 형식과 용량을 확인하세요.") {
        const candidates = [
            error?.message,
            error?.data?.message,
            error?.response?.message,
            error?.error,
            error?.responseJSON?.data?.message,
            error?.responseJSON?.message,
            error?.responseText,
        ];
        for (const candidate of candidates) {
            const text = this.errorText(candidate);
            if (text) return text;
        }
        return fallback;
    }

    public errorText(value: any) {
        if (!value) return "";
        if (typeof value === "object") {
            return this.errorText(value.message || value.error || value.data?.message || "");
        }
        const text = String(value).trim();
        const parsed = this.parseJson(text);
        if (parsed && typeof parsed === "object") return this.errorText(parsed);
        if (!text || text === "[object Object]" || text === "Object Object") return "";
        if (/Traceback|File \"|\/opt\/|storage_key|file_path|applicant_pdf|\.py\b|<html/i.test(text)) return "";
        return text.length > 180 ? `${text.slice(0, 180).trim()}...` : text;
    }

    public formatBytes(size: number) {
        if (size >= 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`;
        if (size >= 1024) return `${(size / 1024).toFixed(1)} KB`;
        return `${size || 0} B`;
    }

    public badgeClass(status: string) {
        status = status || "";
        if (status === 'FAIL_CANDIDATE' || status === 'MISSING_EVIDENCE' || status === 'MISMATCH' || status === 'FAILED' || status === 'REJECTED') return 'bg-rose-50 text-rose-700 border border-rose-200';
        if (status === 'PERMISSION_REQUIRED') return 'bg-zinc-50 text-zinc-600 border border-zinc-200';
        if (status === 'NEEDS_REVIEW' || status === 'NEEDS_HUMAN_REVIEW' || status === 'MANUAL_REVIEW_REQUIRED' || status === 'MANUAL_CHECK_REQUIRED' || status === 'REVIEWER_REQUIRED' || status === 'LOW_CONFIDENCE' || status === 'MULTIPLE_CANDIDATES' || status === 'EMPTY_TEXT_LAYER' || status === 'UNREADABLE' || status === 'PARTIAL_MATCH' || status === 'INSUFFICIENT_EVIDENCE' || status === 'NEEDS_ADMIN_CONFIRMATION' || status === 'APPROVAL_REQUIRED' || status === 'APPROVAL_REQUESTED' || status === 'PENDING' || status === 'ON_HOLD') return 'bg-amber-50 text-amber-700 border border-amber-200';
        if (status === 'REVIEW_COMPLETED' || status === 'MATCHED' || status === 'PASS' || status === 'PASS_CANDIDATE' || status === 'CLASSIFIED' || status === 'EXTRACTED' || status === 'available' || status === 'CONFIRMED' || status === 'FINAL_ACCEPTED') return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
        if (status === 'PROCESSING' || status === 'QUEUED' || status === 'processing' || status === 'queued') return 'bg-sky-50 text-sky-700 border border-sky-200';
        if (status === 'COMPLETED' || status === 'completed') return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
        if (status === 'FAILED' || status === 'failed') return 'bg-rose-50 text-rose-700 border border-rose-200';
        if (status === 'disabled') return 'bg-zinc-50 text-zinc-500 border border-zinc-200';
        if (status === 'AUTO' || status === 'MIXED' || status === 'AUTO_SCORE_DRAFT') return 'bg-sky-50 text-sky-700 border border-sky-200';
        if (status === 'NOT_SCORED_BY_AI') return 'bg-zinc-50 text-zinc-600 border border-zinc-200';
        return 'bg-zinc-50 text-zinc-600 border border-zinc-200';
    }
}

export default PageApplicantsItemComponent;